export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";